/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScoringSubmissionScoringSchemaName } from './scoringSubmissionScoringSchemaName';
import type { ScoringSubmissionScores } from './scoringSubmissionScores';

/**
 * Format how to submit scores to the API, just via key
 */
export interface ScoringSubmission {
  scoringSchemaName?: ScoringSubmissionScoringSchemaName;
  scores: ScoringSubmissionScores;
}
